import request from '@/helpers/request'
import Vue from 'vue'
import snack from '@/helpers/snack'

export default {
  GET_COMPANIES: ({ commit, state }, payload = {}) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.companies.all}`,
      {
        params: payload.params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const companies = response.data.data
        commit('setCompanies', companies.items)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  async GET_COMPANIES_TYPES({ commit, state }, payload = {}) {
    try {
      const {
        data: {
          data: { items },
        },
      } = await request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.companies.types}`, {}, true)
      commit('setCompaniesTypes', items)
    } catch (err) {
      Vue.notify({
        group: 'hasBottomNavigation',
        type: 'error',
        text: 'При загрузке произошла ошибка',
      })
    }
  },
  async FETCH_COMPANIES(context, payload) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.companies.all}`,
        {
          params: payload,
        },
        true,
      )
      return {
        items: response.data.data.items,
        count: response.data.data.count,
      }
    } catch (e) {
      console.info(e)
      snack.add(Vue.config.localization.ru.loadingError)
      return []
    }
  },

  async FETCH_COMPANY({ commit }, id) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.companies.one.replace('$company_id', id)}`,
        {
          params: {
            with: 'images',
          },
        },
        true,
      )
      commit('setCompany', response.data.data)
    } catch (e) {
      console.info(e)
      snack.add(Vue.config.localization.ru.loadingError)
      return {}
    }
  },

  async FETCH_USER_COMPANY({ commit, getters }) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.companies.one.replace('$company_id', getters.userCompany)}`,
        {
          params: {
            with: 'images',
          },
        },
        true,
      )
      commit('setUserCompany', response.data.data)
    } catch (e) {
      snack.add(Vue.config.localization.ru.loadingError)
      return {}
    }
  },

  GET_COMPANY({ commit, state }, companyId) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.companies.one.replace('$company_id', companyId)}`,
      {},
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const company = response.data.data
        commit('setCompany', company)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  ADD_PHOTO(context, { companyId, addedImage }) {
    try {
      let formData = new FormData()
      formData.append('image', addedImage)
      return request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.companies.imageAdd.replace('$company_id', companyId)}`,
        formData,
        true,
      )
    } catch {
      throw new Error()
    }
  },
  DELETE_PHOTO(context, { companyId, oldPhotoId }) {
    try {
      return request(
        'DELETE',
        `${Vue.config.server}/${Vue.config.modules.crm.api.companies.imageUpdate
          .replace('$company_id', companyId)
          .replace('$image_id', oldPhotoId)}`,
        {},
        true,
      )
    } catch {
      throw new Error()
    }
  },
  CREATE_COMPANY(context, payload) {
    try {
      return request('POST', `${Vue.config.server}/${Vue.config.modules.crm.api.companies.create}`, payload, true)
    } catch {
      throw new Error()
    }
  },

  UPDATE_COMPANY(context, { companyId, params }) {
    try {
      return request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.companies.update.replace('$company_id', companyId)}`,
        params,
        true,
      )
    } catch {
      throw new Error()
    }
  },

  /**
   * @return {string}
   */
  async DELETE_COMPANY(context, payload) {
    try {
      const response = await request(
        'DELETE',
        `${Vue.config.server}/${Vue.config.modules.crm.api.companies.delete.replace('$company_id', payload)}`,
        {},
        true,
      )
      return response.data.result
    } catch (e) {
      snack.add(Vue.config.localization.ru.errorDeletingMessage)
      return 'Fail'
    }
  },
}
